<template>
    <!-- 五险明细表 -->
    <div>
        <!-- <div style="font-size:20px;float:left;margin:40px;font-weight:600">五险明细表</div> -->

        <!-- 列表 -->
        <div style="height:850px;background-color:white;margin:5px 5px 20px 5px;padding-bottom: 20px;">
            <!-- 查询框 -->
            <div style="margin-left:3%">
                <el-row style=" padding: 20px 0;">
                    <el-col :span="4">
                        <span>五险账户</span>
                        <el-select v-model="condition.partnerAbbreviation" placeholder="请选择五险账户"
                            style="width: 65%; margin-left: 10px;" filterable>
                            <el-option label="请选择" value=""></el-option>
                            <el-option v-for="item in partnerList" :key="item.id" :label="item.partner_abbreviation"
                                :value="item.id"></el-option>
                        </el-select>
                    </el-col>
                    <el-col :span="4">
                        <span>缴纳城市</span>
                        <el-input v-model="condition.insuredCity" placeholder="请输入缴纳城市"
                            style="width: 65%; margin-left: 10px;">
                        </el-input>
                    </el-col>
                    <el-col :span="4">
                        <span>五险基数</span>
                        <el-input v-model="condition.cardinalNumber" placeholder="请输入五险基数"
                            style="width: 65%; margin-left: 10px;">
                        </el-input>
                    </el-col>

                    <el-col :span="3">
                        <span>姓名</span>
                        <el-input v-model="condition.staffName" placeholder="请输入姓名"
                            style="width: 70%; margin-left: 10px;">
                        </el-input>
                    </el-col>

                    <el-col :span="4">
                        <span>身份证号</span>
                        <el-input v-model="condition.staffCard" placeholder="请输入身份证号"
                            style="width: 65%; margin-left: 10px;">
                        </el-input>
                    </el-col>

                    <el-col :span="4">
                        <span>员工状态</span>
                        <el-select v-model="condition.staffState" placeholder="请选择员工状态"
                            style="width: 65%; margin-left: 10px;" filterable>
                            <el-option label="请选择" value=""></el-option>
                            <el-option v-for="item in roleList" :key="item.id" :label="item.label" :value="item.id">
                            </el-option>
                        </el-select>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="3">
                        <el-button
                            style="width: 85px; background-color: #006E4B; color: #FFFFFF; border: 1px solid #006E4B;"
                            @click="Find">
                            查询</el-button>
                        <!-- <el-button
                            style="width: 85px; background-color: #006E4B; color: #FFFFFF; border: 1px solid #006E4B;"
                            @click="Update">
                            更新</el-button> -->
                    </el-col>
                    <el-col :span="2">
                        <download-excel class="export-excel-wrapper" :fields="download_excel" name="五险明细表"
                            :fetch="ExportForm" style="top:100px; width:5%">
                            <el-button
                                style="width: 85px; background-color: #006E4B; color: #FFFFFF; border: 1px solid #006E4B;">
                                导出</el-button>
                        </download-excel>
                    </el-col>
                </el-row>

            </div>

            <!-- 表格 -->
            <div style="margin:0 3%;margin-top:30px">
                <el-row>
                    <el-table :header-cell-style="{ background: '#d3eae2', color: '#000000' }" height="574px"
                        :row-class-name="tableRowClassName" ref="multipleTable" :data="tableData" tooltip-effect="dark"
                        style="width: 100%" @selection-change="handleSelectionChange">
                        <el-table-column align="center" label="序号">
                            <template slot-scope="scope_1">
                                {{ scope_1.$index + 1 }}
                            </template>
                        </el-table-column>
                        <el-table-column prop="framework" align="center" label="架构"></el-table-column>
                        <el-table-column prop="insuredCity" align="center" label="缴纳城市"></el-table-column>
                        <el-table-column prop="staffName" align="center" label="员工姓名"></el-table-column>
                        <el-table-column prop="staffCard" align="center" label="身份证号码"></el-table-column>
                        <el-table-column prop="insuredBeginYear" align="center" label="开始缴纳年度"></el-table-column>
                        <el-table-column prop="insuredBeginMonth" align="center" label="开始缴纳月份"></el-table-column>
                        <el-table-column prop="socialSecurityNo" align="center" label="个人养老编号"></el-table-column>
                        <el-table-column prop="medicalInsuranceNo" align="center" label="个人医保编号"></el-table-column>
                        <el-table-column prop="fiveInsuranceCompany" align="center" label="五险单位部分"></el-table-column>
                        <el-table-column prop="payLargeTreatmentCompany" align="center" label="医保大额"></el-table-column>
                        <el-table-column align="center" label="五险单位合计">
                            <template slot-scope="scope">
                                {{ bank(scope.row.fiveInsuranceCompany, scope.row.payLargeTreatmentCompany) }}
                            </template>
                        </el-table-column>
                        <el-table-column prop="fiveInsurancePersonage" align="center" label="五险个人部分"></el-table-column>

                        <el-table-column prop="payLargeTreatmentPersonage" align="center" label="医保大额">
                        </el-table-column>
                        <el-table-column align="center" label="五险个人合计">
                            <template slot-scope="scope">
                                {{ bank(scope.row.fiveInsurancePersonage, scope.row.payLargeTreatmentPersonage) }}
                            </template>
                        </el-table-column>
                        <el-table-column prop="commonMpeCompany" align="center" label="公积金单位部分"></el-table-column>
                        <el-table-column prop="commonMpePersonage" align="center" label="公积金个人部分"></el-table-column>
                        <el-table-column prop="" align="center" label="备注"></el-table-column>
                        <el-table-column prop="staffTelephone" align="center" label="电话号"></el-table-column>
                        <el-table-column prop="staffState" align="center" label="员工状态"></el-table-column>
                        <el-table-column prop="fiveInsuranceState" align="center" label="五险状态"></el-table-column>
                    </el-table>
                </el-row>
                <el-row style="margin-top: 10px; text-align: center;">
                    <el-pagination background @current-change="handleCurrentChange" :page-size="page_size"
                        layout=" prev, pager, next, jumper" :total="total">
                    </el-pagination>
                </el-row>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            //列表相关
            page_num: 1,
            page_size: 10,
            total: 0,
            tableData: [],
            partnerList: [],
            roleList: [{ label: "已停保", id: "0" }, { label: "在缴", id: "1" }],
            //条件
            condition: {
                partnerAbbreviation: "",
                insuredCity: "",
                type: "",
                cardinalNumber: "",
                staffName: "",
                staffCard: "",
                staffState: "",
                fiveInsuranceState: ""
            },

            //复选框ids
            ids: [],

            //页面相关
            dialogVisible: false,

            download_excel: {
                "架构": "framework",
                "缴纳城市": "insuredCity",
                "员工姓名": "staffName",
                "身份证号码": {
                    field: "staffCard",
                    callback: value => {
                        return "&nbsp;" + value;
                    }
                },
                "开始缴纳年度": "insuredBeginYear",
                "开始缴纳月份": "insuredBeginMonth",
                "个人养老编号": "socialSecurityNo",
                "个人医保编号": "medicalInsuranceNo",
                "五险单位部分": "fiveInsuranceCompany",
                "医保大额": "payLargeTreatmentCompany",
                "五险单位合计": "induction_manager",
                "五险个人部分": "fiveInsurancePersonage",
                "医保大额": "payLargeTreatmentPersonage",
                "公积金单位部分": "commonMpeCompany",
                "公积金个人部分": "commonMpePersonage",
                "电话号": "staffTelephone",
                "员工状态": "staffState",
                "五险状态": "fiveInsuranceState",
            },
        }
    },
    methods: {
        bank(e1, e2) {
            if (e1 == "" || e1 == null) e1 = 0;
            if (e2 == "" || e2 == null) e2 = 0;
            var count = (Number(e1) * 1000 + Number(e2) * 1000) / 1000;
            return count;
        },
        //分页
        handleCurrentChange(val) {
            this.page_num = val;
            this.Find();
        },
        async initializeTableTitle() {
            var partnerList = await this.$globals.AxiosPost("partner/selectFind", {});
            this.partnerList = partnerList.data;
        },
        //查询
        async Find() {
            this.initializeTableTitle();
            var url = "report/report/findFiveInsuranceDetailPage";
            var record = {
                pageNum: this.page_num,
                pageSize: this.page_size,
                framework: "",
                partnerAbbreviation: this.condition.partnerAbbreviation,
                insuredCity: this.condition.insuredCity,
                type: this.condition.type,
                cardinalNumber: this.condition.cardinalNumber,
                staffName: this.condition.staffName,
                staffCard: this.condition.staffCard,
                staffState: this.condition.staffState,
                fiveInsuranceState: this.condition.fiveInsuranceState
            };
            var data = await this.$globals.AxiosPost(url, record);
            if (data === "-2000") {
                this.$message.error("服务器未响应！请稍后重试");
            } else {
                var code = data.code;
                var data = data.data;
                if (code === '200') {
                    this.tableData = data.list;
                    this.total = data.total;
                } else {
                    this.$message.warning("请求失败！请稍后重试");
                }
            }
        },
        async ExportForm() {
            this.initializeTableTitle();
            var url = "report/report/findFiveInsuranceDetailList";
            var record = {
                framework: "",
                partnerAbbreviation: this.condition.partnerAbbreviation,
                insuredCity: this.condition.insuredCity,
                type: this.condition.type,
                cardinalNumber: this.condition.cardinalNumber,
                staffName: this.condition.staffName,
                staffCard: this.condition.staffCard,
                staffState: this.condition.staffState,
                fiveInsuranceState: this.condition.fiveInsuranceState
            };
            var data = await this.$globals.AxiosPost(url, record);
            if (data === "-2000") {
                this.$message.error("服务器未响应！请稍后重试");
            } else {
                var code = data.code;
                var data = data.data;
                if (code === '200') {
                    this.tableDatas = data;
                    if (this.tableDatas.length > 0) {
                        this.$message.success("导表成功！文件下载中！");
                        return this.tableDatas;
                    } else {
                        this.$message.success("没有可以导出的数据！");
                        return null;
                    }
                } else {
                    this.$message.warning("请求失败！请稍后重试");
                }
            }
        },
        //清除数据
        trash() {
            this.from.data = "";
            this.from.id = "";
        }
    },
    created() {
        this.Find();
    }
}
</script>

<style scoped="scoped">
.el-button--goon:focus,
.el-button--goon:hover {
    background: #006E4B;
    color: #fff;
}

.el-button--goon {
    color: #FFF;
    background-color: #006E4B;
    width: 85px;
}

.el-table .warning-row {
    background: oldlace;
}

.el-table .success-row {
    background: #f0f9eb;
}
</style>


// WEBPACK FOOTER //
// five_insurances_detailed.vue?61f5656c